/* eslint-disable max-len */
import React, { useEffect } from "react";

import AppointmentCardList from "../../../components/Appointments/AppointmentCardList";
import { Button } from "@mui/material";
import { CloseIcon } from "../../../components/Icons";
import { LoadingOverlay } from "../../../components";
import { useDashboard } from "../../../services/dashboard/dashboard.service";
import { useModal } from "../../../context/ModalContext";
import { useNavigate } from "react-router-dom";
import { useUserDetail } from "../../../services/user-detail/user-detail.service";

const ManageHospitalChangeModal = () => {
  const { closeModal } = useModal();
  const { getDashBoardData, dashboard } = useDashboard();
  const { user } = useUserDetail();
  const navigate = useNavigate();


  const handleManageBooking = () =>{
    navigate("/dashboard");
  };
  const handleCloseIcon = () =>{
    closeModal();
  };

  useEffect(()=>{
    getDashBoardData();
  }, []);


  return (
    dashboard && dashboard.appointments.length > 0 ? <div className="relative flex flex-col justify-between h-[95%] gap-4 p-2">

      <div>
        <div onClick={handleCloseIcon} className="flex justify-end cursor-pointer">
          <CloseIcon width = {20} height = {20} />
        </div>
        <div className="text-xl font-semibold text-center geograph-regular">
        Change Home Hospital
        </div>
      </div>

      <div className="h-[80%] overflow-y-auto flex flex-col justify-between py-6 pe-2">
        <div className="flex-grow flex flex-col gap-4 items-center">
          <div><img src="/assets/icons/TennisBall.png" style={{ height: 40, width: 40 }} /></div>
          <div className="text-center font-semibold w-4/6">You have an upcoming appointment at your current hospital</div>
          <div className="w-full">
            {dashboard && <AppointmentCardList appointments={dashboard?.appointments} className="flex flex-col gap-1" />}
          </div>
        </div>
        <div className="bg-taupe-1 p-3 text-sm text-center rounded-xl">
        We understand plans change. Please cancel or complete your upcoming appointment at{" "}
          <span className="font-semibold capitalize">{user?.location?.locationName}</span> before changing your home hospital.
        </div>
      </div>

      <Button
        size="medium"
        type="button"
        variant="outlined"
        className="!bg-gray-3 !text-sm !normal-case font-semibold w-full border !border-taupe-2"
        onClick={handleManageBooking}>
        Manage Booking
      </Button>
    </div>:
      <LoadingOverlay />
  );
};

export default ManageHospitalChangeModal;
